import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography } from 'seagull';
import ExternalLinkButton from '~/components/ExternalLinkButton';
import { useLocaleKeys } from '~/i18n';
export const PingSteps = ()=>{
    const { t: pingTexts } = useLocaleKeys('integrations.ping');
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                children: pingTexts.stepOpenIntegrations()
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: pingTexts.stepPasteApiKey()
            }),
            /*#__PURE__*/ _jsx(ExternalLinkButton, {
                href: "https://help.sayanchor.com/en/articles/15293356-ping",
                openInNewTab: true,
                style: {
                    marginTop: 16
                },
                testId: "ping-help-center-link",
                bi: {
                    name: 'ping_help_center_link'
                },
                children: pingTexts.readMoreInHelpCenter()
            })
        ]
    });
};
